import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpUrlGenerator } from "@ngrx/data";
import { ApiResponse, RestService } from "@recore-solutions/nstar-lib";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { NstarDataService } from "src/app/nstar-data.service";
import { environment } from "src/environments/environment";
import { OpenHouseAudit } from "../../../shared/interfaces/open-house-audit";

@Injectable({
	providedIn: "root",
})
export class OpenHouseAuditDataService extends NstarDataService<OpenHouseAudit> {
	constructor(
		protected httpClient: HttpClient,
		protected httpUrlGenerator: HttpUrlGenerator,
		protected restService: RestService
	) {
		super("OpenHouseAudit" as never, httpClient, httpUrlGenerator);
	}

	getOpenHouseAuditApiResponse(queryParams?: Record<string, any>): Observable<OpenHouseAudit[]> {
		const params = this.queryParamsToHttpParams(queryParams);
		return this.restService
			.get<ApiResponse<OpenHouseAudit>>(environment.endpoints.openHouseHistory, params)
			.pipe(
				map((response) => response?.records || []),
				catchError(() => of([]))
			);
	}

	getAll(): Observable<OpenHouseAudit[]> {
		return this.getOpenHouseAuditApiResponse();
	}

	getWithQuery(params: Record<string, any>): Observable<OpenHouseAudit[]> {
		return this.getOpenHouseAuditApiResponse(params);
	}
}
